module.exports = __webpack_public_path__ + "img/beleza.4b8370e1.png";